import { apiSecureRequest } from '../utils/request';

export async function trackContent(urlSlug: string, contentType: string): Promise<void> {
	await apiSecureRequest.post('/content/track', {
		urlSlug,
		contentType
	});
}
